// extracted by mini-css-extract-plugin
export var headerSearch = "HeaderSearch-module--headerSearch--87c3b";
export var headerSearch__clear = "HeaderSearch-module--headerSearch__clear--a569e";
export var headerSearch__icon = "HeaderSearch-module--headerSearch__icon--1a758";
export var headerSearch__input = "HeaderSearch-module--headerSearch__input--40524";